import type { SportConfig } from '../types/sport';

export const hockeyConfig: SportConfig = {
  id: 'hockey',
  name: { ru: 'Хоккей', en: 'Hockey' },
  icon: 'hockey',
  color: '#6366F1',
  defaults: {
    teamMode: '2_teams',
    scoringMode: 'team_score',
    maxParticipants: 12,
    durationMinutes: 90,
    teamsCount: 2,
    hasParticipantLimit: true,
    participantStep: 2,
  },
  scoring: {
    type: 'team_score',
    labels: { ru: ['Команда А', 'Команда Б'], en: ['Team A', 'Team B'] },
  },
  shuffle: {
    enabled: true,
    modes: ['ai', 'snake_draft'],
    factors: ['rating', 'recent_form', 'reliability', 'experience', 'mvp_count'],
  },
  ratings: { enabled: true, scale: { min: 1, max: 5 }, anonymous: true },
  mvp: { enabled: true, perTeam: true },
  positions: null,
  supportsMultiMatch: true,
  playersPerTeam: 6,
};
